import { Grid } from '@mui/material'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'
import { MInspector } from '@Models/client/inspection.model'
import { ICommonQuery } from '@Models/common.model'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as Redux from 'redux'
import ClientInspectionActions from '@ClientActions/inspection.action'
import * as _ from 'lodash'
import clsx from 'clsx'
import useSearch from '@Hooks/useSearch'
import Loading from '@Components/Loading/Loading'
import { APIServices } from '@Services/api.service'
import UserInfoBox from '@Components/Box/UserInfoBox/UserInfoBox'

// models section
interface IInspectorModal {
    open: boolean
    onClose: () => void
    getSelectedInspectors: (inspectors: MInspector[]) => void
    defaultInspectors: MInspector[]

    // redux
    getInspectors?: () => void
    setInspectorQueries?: (params?: ICommonQuery) => void
    inspectors?: MInspector[]
    inspectorLoading?: boolean
}

const InspectorModal = (props: IInspectorModal) => {
    // core section
    const {
        open,
        onClose,
        inspectors,
        getInspectors,
        setInspectorQueries,
        inspectorLoading,
        getSelectedInspectors,
        defaultInspectors,
    } = props

    // states section
    const [selectedInspectors, setSelectedInspectors] = useState<MInspector[]>(
        []
    )
    const [coords, setCoords] = useState({ latitude: 0, longitude: 0 })
    const [filteredInspectors, setFilteredInspectors] = useState<MInspector[]>(
        []
    )

    // custom hooks
    const [search, setDebounceSearch] = useSearch('')
    useEffect(() => {
        if (setInspectorQueries && getInspectors) {
            setInspectorQueries({ search: search?.debounceString })
            getInspectors()
        }
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [search?.debounceString])

    // hooks section
    /**
     * perform inspectors checking and remove if inspectors exist
     */
    useEffect(() => {
        const different = _.differenceWith(
            inspectors,
            defaultInspectors,
            _.isEqual
        )
        setFilteredInspectors(different)
        return () => {
            setFilteredInspectors([])
        }
    }, [inspectors])

    /**
     * get data from API when modal is open
     */
    useEffect(() => {
        window.navigator.geolocation.getCurrentPosition((e) => {
            const { latitude, longitude } = e?.coords
            setCoords({ latitude, longitude })
        })
        if (setInspectorQueries) setInspectorQueries(coords)
        if (getInspectors && open) getInspectors()
        setSelectedInspectors([])
        return () => {
            setSelectedInspectors([])
        }
    }, [open])

    // functions section
    /**
     * perform select inspector add only new, if inspector already exist remove
     * @param inspector inspector obj
     */
    const handleSelectInspector = (inspector: MInspector) => {
        // const existInspector = selectedInspectors?.filter(
        //     (item: MInspector) => inspector?.inspectorId === item?.inspectorId
        // )
        // if (existInspector?.length) {
        //     const removedInspectors = selectedInspectors?.filter(
        //         (item: MInspector) =>
        //             item?.inspectorId !== inspector?.inspectorId
        //     )
        //     setSelectedInspectors(removedInspectors)
        // } else {
        //     setSelectedInspectors((prevState) => [...prevState, inspector])
        // }
    }

    const handleAddDirectory = () => {
        if (!selectedInspectors?.length) return
        onClose()
        getSelectedInspectors(selectedInspectors)
    }

    // main
    return (
        <CustomModal
            modalTitle="Directory of Inspectors"
            open={open}
            onClose={(reason: string) => {
                // if (reason === 'backdropClick') return
                onClose()
            }}
            // modalType="review"
            className="inspection-modal"
        >
            <div className="modal-body p-0">
                <div className="mb-3">
                    <input
                        type="text"
                        className="search-box"
                        placeholder="Search"
                        value={search?.searchString}
                        onChange={(e: any) => {
                            setDebounceSearch(e?.target?.value)
                        }}
                    />
                </div>
                <div className="position-relative inspectors-container">
                    <Loading
                        isLoading={inspectorLoading}
                        className="inspector-modal-loading"
                    />
                    <Grid container spacing={2}>
                        {filteredInspectors?.length && !inspectorLoading ? (
                            filteredInspectors?.map(
                                (inspector: MInspector, index: number) => {
                                    const selectedInspector = selectedInspectors
                                        ?.map((item) => item?.inspectorId)
                                        .includes(inspector?.inspectorId)
                                    return (
                                        <Grid
                                            item
                                            md={6}
                                            sm={12}
                                            xs={12}
                                            key={+index}
                                        >
                                            <UserInfoBox
                                                user={inspector}
                                                className={clsx(
                                                    'user-info-box',
                                                    selectedInspector &&
                                                        'border-danger'
                                                )}
                                                onClick={() =>
                                                    handleSelectInspector(
                                                        inspector
                                                    )
                                                }
                                                selected={selectedInspector}
                                            />
                                        </Grid>
                                    )
                                }
                            )
                        ) : (
                            <Grid item md={12}>
                                <div className="w-100 text-center">No data</div>
                            </Grid>
                        )}
                    </Grid>
                </div>
            </div>
            <div className="modal-footer mt-3">
                <span className="modal-action" onClick={onClose}>
                    Close
                </span>
                {/* <p
                    className={clsx(
                        'modal-action main-text text-center m-auto',
                        !selectedInspectors?.length && 'disabled-add-directory'
                    )}
                    onClick={handleAddDirectory}
                >
                    Add{' '}
                    {selectedInspectors?.length > 1
                        ? 'Directories'
                        : 'Directory'}
                </p> */}
            </div>
        </CustomModal>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { inspectors, inspectorLoading } = store?.client?.inspections
    return {
        inspectors,
        inspectorLoading,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getInspectors, setInspectorQueries } = ClientInspectionActions
    return {
        getInspectors: () => dispatch(getInspectors() as any),
        setInspectorQueries: (params?: ICommonQuery) =>
            dispatch(setInspectorQueries(params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InspectorModal)
